<template>
    <form-wizard
        class="form-wizard"
        ref="FormWizard"
        v-bind="$props"
        @on-change="handleOnChange"
    >
        <slot />

        <template
            slot="footer"
            slot-scope="props"
        >
            <div class="wizard-footer-left">
                <rkm-button
                    v-if="props.activeTabIndex"
                    color="primary"
                    @click.stop="props.prevTab()"
                    :disabled="disabledPrevButton"
                >
                    Voltar
                </rkm-button>
            </div>

            <div class="wizard-footer-right">
                <rkm-button
                    v-if="!props.isLastStep"
                    color="primary"
                    @click.stop="props.nextTab()"
                    :disabled="disabledNextButton"
                >
                    Próximo
                </rkm-button>

                <rkm-button
                    v-else
                    color="primary"
                    @click.stop="$emit('finish')"
                    :disabled="disabledFinishButton"
                >
                    Concluir
                </rkm-button>
            </div>
        </template>
    </form-wizard>
</template>

<script>
import { FormWizard } from 'vue-form-wizard'

export default {
    components: { FormWizard },
    props: {
        title: { type: String, default: '' },
        subtitle: { type: String, default: '' },
        shape: { type: String, default: 'circle' },
        color: { type: String, default: 'var(--primary)' },
        disabledPrevButton: { type: Boolean, default: false },
        disabledNextButton: { type: Boolean, default: false },
        disabledFinishButton: { type: Boolean, default: false },
        scrollToTopOnChange: { type: Boolean, default: true },
    },
    methods: {
        reset() {

            this.$refs.FormWizard.reset()
        },
        activateAll() {

            this.$refs.FormWizard.activateAll()
        },
        nextTab() {

            this.$refs.FormWizard.nextTab()
        },
        prevTab() {

            this.$refs.FormWizard.prevTab()
        },
        changeTab(oldIndex, newIndex) {

            this.$refs.FormWizard.changeTab(oldIndex, newIndex)
        },
        handleOnChange(prevIndex, nextIndex) {

            if (this.scrollToTopOnChange) {

                scrollTo(0, 0);
            }

            this.$emit('change', prevIndex, nextIndex)
        }
    }
}
</script>

<style scoped>
.form-wizard >>> [role="tablist"] {
    padding: 0;
    margin: -0.75rem 0 0.75rem 0;
    display: flex;
    justify-content: space-between;
    align-items: stretch;
}
.form-wizard >>> [role="tablist"] li {
    list-style: none;
    flex: 1;
}

.form-wizard >>> [role="tablist"] li a {
    padding: 0 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    text-decoration: none;
    position: relative;
    text-align: center;
    flex: 1;
}

.form-wizard >>> a.disabled {
    opacity: 0.6;
    color: var(--gray);
    cursor: not-allowed;
}

.form-wizard >>> .wizard-icon-circle {
    width: 50px;
    height: 50px;
    border-radius: 100%;
    color: #FFF;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid currentColor !important;
    color: currentColor;
    line-height: 1;
}

.form-wizard >>> .active .wizard-icon-circle {
    background: var(--primary);
    color: #FFF;
}

.form-wizard >>> .wizard-icon {
    font-style: normal;
    font-weight: 200;
    font-size: 18px;
}


.wizard-icon-container {
    background: none !important;
}

.wizard-icon {
    font-style: normal;
}

.form-wizard >>> [role="tablist"] li + li a:before {
    content: '';
    display: block;
    position: absolute;
    top: 24px;
    left: -20%;
    height: 2px;
    width: 40%;
    background: currentColor;
}

.form-wizard >>> .wizard-card-footer {
    display: flex;
    justify-content: space-between;
    margin: 1rem -0.75rem 0;
    padding: 0.75rem 0.75rem 0 0.75rem;
    border-top: 1px solid #dee2e6;
    flex-wrap: nowrap;
}

.form-wizard >>> .wizard-footer-left, .form-wizard >>> .wizard-footer-right {
    flex-shrink: 1;
}

.form-wizard >>> .wizard-card-footer:after {
    display: none !important;
}
</style>